// extracted by mini-css-extract-plugin
module.exports = {"InputBox":"_3iSSJ","searchBtn":"Vwr46","SearchBox":"_32j7a","SearchBox_active":"gPKIR"};